const Sentry = require('@sentry/node');
const SentryIntegrations = require('@sentry/integrations');

module.exports = (release = process.env.SENTRY_RELEASE) => {
  const sentryOptions = {
    dsn:
      'https://577c8baf824c4c85822295960aaca96d@sentry.app.osl.pubops.net/30',
    release,
    maxBreadcrumbs: 50,
    attachStacktrace: true,
  };

  if (process.env.NODE_ENV !== 'production') {
    sentryOptions.beforeSend = () => null;

    sentryOptions.integrations = [
      new SentryIntegrations.Debug({
        debugger: false,
      }),
    ];
  }

  Sentry.init(sentryOptions);

  return {
    Sentry,
    captureException: (err, ctx) => {
      Sentry.configureScope(scope => {
        if (err.message) {
          // De-duplication currently doesn't work correctly for SSR / browser errors
          // so we force deduplication by error message if it is present
          scope.setFingerprint([err.message]);
        }

        if (err.statusCode) {
          scope.setExtra('statusCode', err.statusCode);
        }

        if (ctx) {
          const { req, res, errorInfo, query, pathname } = ctx;

          if (res && res.statusCode) {
            scope.setExtra('statusCode', res.statusCode);
          }

          if (typeof window !== 'undefined') {
            scope.setTag('ssr', false);
            scope.setExtra('query', query);
            scope.setExtra('pathname', pathname);
          } else {
            scope.setTag('ssr', true);
            scope.setExtra('url', req.url);
            scope.setExtra('method', req.method);
            scope.setExtra('headers', req.headers);
            scope.setExtra('params', req.params);
            scope.setExtra('query', req.query);
          }

          if (errorInfo) {
            Object.keys(errorInfo).forEach(key =>
              scope.setExtra(key, errorInfo[key])
            );
          }
        }
      });

      return Sentry.captureException(err);
    },
  };
};
